// extracted by mini-css-extract-plugin
export default {"Bprivacy":"airPrivacy_Bprivacy__gVC2p","pt18":"airPrivacy_pt18__nfGsr","pt12":"airPrivacy_pt12__mnUfj","pt135":"airPrivacy_pt135__9HSD1"};